<template>
  <div class="xubao-dialog">
    <div class="xubao-dialog__close-btn" @click="handleClose"></div>
    <div class="xubao-dialog__content">
      当前课程并非原班课程，你可以继续报名此课程或去学习中心原班续报
    </div>
    <div class="xubao-dialog__button-group clear">
      <a class="left-button button" @click="linkHandle($event)" href="//i.xueersi.com"
        >去学习中心</a
      >
      <div class="right-button button" @click="handleBuyCourse($event)">报名此课</div>
    </div>
  </div>
</template>

<script>
import mixin from '@/modules/dialog-builder/mixin'

export default {
  name: 'xubao-dialog',
  mixins: [mixin],
  methods: {
    handleClose() {
      this.resolve(false)
    },
    linkHandle(event) {
      this.resolve(false)
      const XESLog = new this.$XESLog({
        key: `xeslog-liveCourseDetail-www`,
        clickid: '1.3.31',
        button: 'studyCenter',
        action: 'continueToI',
        platformid: '1000012',
        classid: this.$route.params.classId,
        courseid: this.$route.params.courseId
      })
      XESLog.push({ eventname: 'click', target: event.target }, this.$route)
    },
    handleBuyCourse(event) {
      this.resolve(true)
      const XESLog = new this.$XESLog({
        key: `xeslog-liveCourseDetail-www`,
        clickid: '1.3.32',
        button: 'enroll',
        platformid: '1000012',
        action: 'continueApplyThis',
        classid: this.$route.params.classId,
        courseid: this.$route.params.courseId
      })
      XESLog.push({ eventname: 'click', target: event.target }, this.$route)
    }
  }
}
</script>

<style lang="scss" scoped>
@import 'src/scss/entry';
.small {
  font-size: 14px;
}
@include b(xubao-dialog) {
  position: fixed;
  top: 300px;
  left: 50%;
  transform: translateX(-50%);
  width: 466px;
  border-radius: 2px;
  overflow: hidden;
  background: #ffffff;
  @include e(content) {
    padding-top: 78px;
    width: 366px;
    margin: 0 auto;
    line-height: 21px;
    text-align: center;
    font-size: 14px;
    color: #333;
  }
  @include e(close-btn) {
    width: 16px;
    height: 16px;
    position: absolute;
    top: 10px;
    right: 10px;
    background-image: url('~@/views/CourseDetail/images/close-btn-gray.png');
    background-size: cover;
    background-repeat: no-repeat;
    cursor: pointer;
  }
  @include e(button-group) {
    height: 83px;
    padding-top: 28px;
    position: relative;
    .button {
      width: 130px;
      height: 40px;
      display: inline-block;
      font-size: 14px;
      line-height: 40px;
      text-align: center;
      border-radius: 2px;
      cursor: pointer;
    }
    .left-button {
      color: #333333;
      border: 1px solid #cccccc;
      margin-left: 76px;
    }
    .right-button {
      float: right;
      margin-right: 76px;
      background-color: #f13232;
      color: #fff;
      border: 1px solid #f13232;
    }
  }
}
</style>



// WEBPACK FOOTER //
// ./src/views/CourseDetail/components/XubaoDialog.vue